import {ThreeEquipment} from '../ThreeEquipment/ThreeEquipment';

export class ThreePortableEquipment extends ThreeEquipment {

}